import {
  getWordByCoordinates,
  getWordIndexByCoordinates,
  getWordByCoordinatesOutside,
  wait,
} from '../../common/functions';
import { first, last, findLastIndex } from 'lodash';

// ***************************************************************************************
// onMouseDown()
// Quand on entre en action avec la souris
// ***************************************************************************************
let startMouseX = null;
let startMouseY = null;
let startWordIndex = -1;
let selecting = false;

export async function onMouseDown(event) {  
  if (!this.subtitle || this.props.readOnly) {
    return;
  }

  if(!this.subtitle.lines) {
    return;
  }

  if (this.state.contextMenu.display) {
    this.onCloseContextMenu();
  }

  // on doit rejouer l'action pour rafraichir le canvas
  if (!this.state.active) {
    this.setState({ active: true });
   // this.onRefreshCanvas();

    //await wait(100);
  }

  // si on a un mot vide, on le supprime et on refait l'action
  if (this.hasEmptyWord) {
    this.removeEmptyWord('onMouseDown').then(() => this.onMouseDown(event));
    return;
  }

  let { offsetX, offsetY, clientX } = event.nativeEvent;

  // Calculer les ratios de zoom pour adapter les coordonnées souris
  const rect = this.foreCanvas.current.getBoundingClientRect();
  if (clientX < rect.x) {
    return;
  }

  const displayScaleX = rect.width / this.width;
  const displayScaleY = rect.height / this.height;
 
  offsetX = offsetX / displayScaleX;
  offsetY = offsetY / displayScaleY;

  offsetY += this.lineHeight;

  startMouseX = offsetX;
  startMouseY = offsetY;

  if (!selecting && this.underSelection) {
    this.underSelection = false;
    this.wordsToSelect = [];
    this.lettersToSelect = [];
    this.onRefreshCanvas();
  }

  // on supprime la ligne
  if (
    this.subtitle.lines.length > 1 &&
    this.currentLine &&
    !this.currentLine.words.length
  ) {
    this.deleteLine();
    this.onChange();
    await wait(100);
  }

  const words = this.getWords();
  // si le sous-titre n'a aucun mot
  if (!words.length) {
    this.currentLetterIndex = 0;
    this.currentWordIndex = 0;
    this.currentLineIndex = 0;
    this.onMove();
    return;
  }

  // On va prendre le mot la plus proche des coordonnées x et y
  let nextWord = getWordByCoordinates(this.subtitle.lines, offsetX, offsetY);
  if (!nextWord) {
    const { closestLine, closestWord } = getWordByCoordinatesOutside(
      this.subtitle.lines,
      offsetX,
      offsetY
    );

    if (closestWord) {
      nextWord = closestWord;
      let nextLetter =
        nextWord.index === 0 ? first(nextWord.letters) : last(nextWord.letters);

      if (closestLine.words.length === 1) {
        if (nextLetter?.x <= offsetX) {
          nextLetter = last(nextWord.letters);
        }
      }

      this.currentLetterIndex = nextLetter ? nextLetter.indexLetter : 0;
      this.currentWordIndex = nextWord.index;
      this.currentLineIndex = nextWord.indexLine;

      this.currentLetterIndex = nextLetter ? nextLetter.indexLetter : 0;
      this.currentWordIndex = nextWord.index;
      this.currentLineIndex = nextWord.indexLine;
    } else {
      // On prend le premier mot
      const words = this.getWords();
      const firstWord = first(words);

      this.currentLetterIndex = first(firstWord.letters).indexLetter;
      this.currentWordIndex = firstWord.index;
      this.currentLineIndex = firstWord.indexLine;
    }

    this.onMove();
    return;
  }

  // On va prendre la lettre la plus proche des coordonnées x
  let nextLetter = nextWord.letters.find(
    (letter) => letter.x <= offsetX && offsetX <= letter.x + letter.width
  );

  if (!nextLetter) {
    // Si le curseur est placé avant le milieu de l'écran, prendre la première lettre sinon la dernière lettre
    if (this.currentLetter?.x <= this.width / 2) {
      nextLetter = first(nextWord.letters);
    } else {
      nextLetter = last(nextWord.letters);
    }
  } else {
    // si le curseur se pointe vers la fin de la lettre, prendre la lettre suivante
    if (!nextLetter.lastChar && offsetX > nextLetter.x + nextLetter.width / 2) {
      nextLetter = nextWord.letters[nextLetter.index + 1];

      if (!nextLetter) {
        // on prend le mot suivant
        nextWord = this.script[nextWord.index + 1];
        nextLetter = first(nextWord.letters);
      }
    }
  }

  this.currentLetterIndex = nextLetter ? nextLetter.indexLetter : 0;
  this.currentWordIndex = nextWord.index;
  this.currentLineIndex = nextWord.indexLine;

  this.onMove();
}

// ***************************************************************************************
// onMouseMove()
// Quand la souris fait la sélection en pressant sur le bouton gauche
// ***************************************************************************************
let prevMouseX = null;
let prevMouseY = null;
export function onMouseMove(event) {
  if (!event.buttons || !this.subtitle || !this.currentWord || this.props.readOnly) {
    return;
  }

  if (!startMouseX && !startMouseY) {
    return;
  }

  let { offsetX, offsetY } = event.nativeEvent;
  offsetY += this.lineHeight;

  if (!selecting) {
    // si c'est un léger mouvement, ne rien faire
    const diffX = startMouseX - offsetX;
    const diffY = startMouseY - offsetY;

    if (
      diffX >= -5 &&
      diffX <= 5 &&
      diffY >= -this.lineHeight &&
      diffY <= this.lineHeight
    ) {
      return;
    }

    selecting = true;
    this.underSelection = true;
    this.wordsToSelect = [];

    prevMouseX = null;
    prevMouseY = null;
  }

  // Quand on sélectionne le premier mot, déterminer le mot de départ vers le haut ou vers le bas
  if (
    (prevMouseX === null && prevMouseY === null) ||
    this.wordsToSelect.length === 0
  ) {
    startWordIndex = this.currentWord.indexWord;

    let startWord = getWordByCoordinates(this.subtitle.lines, offsetX, offsetY);

    // TODO Si la selection se fait hors champ ?
    if (!startWord) {
      return;
    }
  }

  const words = this.getWords();

  let endIndex = getWordIndexByCoordinates(words, offsetX, offsetY);

  if (endIndex === -1) {
    endIndex = findLastIndex(
      words,
      (word) => word.startY <= offsetY && offsetY <= word.endY
    );
  }

  if (endIndex === -1) {
    prevMouseX = offsetX;
    prevMouseY = offsetY;
    return;
  }

  if (startWordIndex <= endIndex) {
    this.wordsToSelect = [...words.slice(startWordIndex, endIndex + 1)];
  } else {
    this.wordsToSelect = [...words.slice(endIndex, startWordIndex + 1)];
  }

  this.onMove();
}

// ***************************************************************************************
// onMouseUp()
// Quand on lâche la souris
// ***************************************************************************************
export function onMouseUp(event) {
  if (!this.state.active || this.props.readOnly) {
    return;
  }

  // Si je suis en train de sélectionner, j'arrête la sélection
  if (selecting) {
    selecting = false;
    prevMouseX = null;
    prevMouseY = null;
  }

  startMouseX = null;
  startMouseY = null;
}

// ***************************************************************************************
// onDoubleClick()
// Quand on double clique sur un mot, on le sélectionne
// ***************************************************************************************

export function onDoubleClick(event) {
  if (!this.state.active || this.props.readOnly || !this.currentWord) {
    return;
  }

 let { clientX } = event.nativeEvent;
 const rect = this.foreCanvas.current.getBoundingClientRect();
  if (clientX < rect.x) {
    return;
  }

  this.wordsToSelect = [];

  this.underSelection = true;
  this.wordsToSelect.push(this.currentWord);
  this.onRefreshCanvas();
}

export function onClick() {
  if (this.state.contextMenu.display) {
    this.onCloseContextMenu();
  }

  if (this.state.speakerMenu.display) {
    this.onCloseSpeakerMenu();
  }
}